import React, {Fragment} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import * as api from "../../apis/countryMapping";
import useAntTable from "../../utils/useAntTable";
import {Button, Divider, Popconfirm, Space} from "antd";
import WithAuth from "../../utils/withAuth";
import withAuth from "../../utils/withAuth";
import ModifyModal from "./modifyModal";
import useFormModal from "../../utils/useFormModal";
import {useRequest} from "ahooks";

const AddButton = WithAuth('add', Button)
const EditFragment = WithAuth('edit', Fragment)
const DeletePopconfirm = withAuth('delete', Popconfirm)

function CountryMapping() {

    const {tableProps, refresh} = useAntTable(api.getCountryMappings, {})

    const {setVisible, modalProps} = useFormModal({
        onRequest: api.modifyCountryMapping,
        onOk: () => {
            refresh()
            setVisible(false)
        }
    })

    const {run: onDelete} = useRequest(api.deleteCountryMapping, {
        manual: true,
        onSuccess: () => refresh()
    })

    const columns: StandardColumnsType = [
        {
            title: 'Country',
            dataIndex: 'country'
        },
        {
            title: 'Company',
            dataIndex: 'company'
        },
        {
            title: 'Operations',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <span>
                    <EditFragment>
                        <a onClick={() => setVisible(true, record)}>Edit</a>
                        <Divider type="vertical"/>
                    </EditFragment>
                    <DeletePopconfirm title={'Are you sure?'} onConfirm={() => onDelete(record.id)}>
                        <a>Delete</a>
                    </DeletePopconfirm>
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} toolbar={(
                <Space>
                    <AddButton type={'primary'} onClick={() => setVisible(true)}>Add</AddButton>
                </Space>
            )}/>
            <ModifyModal {...modalProps} />
        </PageHeaderLayout>
    )
}

export default CountryMapping;
